import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useDocuments from '../useDocuments';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';
import { useCallback } from 'react';

const MainPage = () => {
  const {
    data,
    columns,
    loading,
    filters,
    onChangeTableFilter,
    handleDownloadExcel,
    onDelete,
  } = useDocuments(true);
  const { t } = useTranslation();

  const pages = useRecoilValue(getPage);
  const navigate = useNavigate();

  const handleOnRow = useCallback(
    (record) => ({
      onClick: () => {
        navigate(`${record.id}`);
      },
    }),
    [navigate],
  );

  return (
    <>
      <PageHeader title={'DOCUMENTI'}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              disabled={loading}
              onClick={handleDownloadExcel}
              icon={<ExcelIcon fill={'#fff'} />}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.company_documents}
          pagination={data.pagination}
          scroll={{ x: 1500 }}
          loading={loading}
          onChange={onChangeTableFilter}
          onRow={handleOnRow}
          // bordered
        />
      </div>
      <Routes>
        <Route path={':id/delete'} element={<DeleteModal loading={loading} onClickDelete={onDelete} />} />
      </Routes>
    </>
  );
};

export default MainPage;
